<compass-stage-breadcrumbs></compass-stage-breadcrumbs>

<section>
  <div class="container">
    <compass-pois-accordion [setup]="accordionHousing">
      <compass-inmuebles></compass-inmuebles>
    </compass-pois-accordion>
  </div>
</section>
